import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ProjectCard = ({ project: p, className = "" }) => (
  <Link
    to={`/project/${p.slug}`}
    data-testid={`project-card-${p.slug}`}
    className={`group block ${className}`}
  >
    <div className="relative overflow-hidden rounded-3xl border border-[#07130C]/10 bg-[#07130C]">
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={p.image}
          alt={`${p.name} — ${p.category} concept for ${p.industry}`}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.07]"
        />
      </div>
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#07130C]/60 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
      <span className="absolute bottom-4 right-4 flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#07130C] shadow-lg transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1">
        <ArrowUpRight className="h-5 w-5" />
      </span>
    </div>
    <div className="mt-5">
      <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#1C7543]">
        {p.category} · {p.industry}
      </p>
      <h3 className="mt-2 font-display text-xl font-semibold tracking-tight text-[#07130C] transition-colors duration-200 group-hover:text-[#1C7543] md:text-2xl">
        {p.name}
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-[#07130C]/60">{p.description}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {p.tech.map((t) => (
          <span
            key={t}
            className="rounded-full border border-[#07130C]/10 px-3 py-1 text-[11px] font-medium text-[#07130C]/60"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </Link>
);
